/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * GO Reserve 乗務レポート１行
 * @export
 * @interface ReserveShiftsReportRow
 */
export interface ReserveShiftsReportRow {
    /**
     * 複数のログイン/ログアウトを乗務単位にまとめるためのID
     * @type {string}
     * @memberof ReserveShiftsReportRow
     */
    shiftId?: string;
    /**
     * shift_start_date
     * @type {string}
     * @memberof ReserveShiftsReportRow
     */
    shiftDate?: string;
    /**
     * 乗務員ID
     * @type {number}
     * @memberof ReserveShiftsReportRow
     */
    officeId?: number;
    /**
     * 営業所名称
     * @type {string}
     * @memberof ReserveShiftsReportRow
     */
    officeName?: string;
    /**
     * 乗務員ID
     * @type {number}
     * @memberof ReserveShiftsReportRow
     */
    driverId?: number;
    /**
     * 乗務員名
     * @type {string}
     * @memberof ReserveShiftsReportRow
     */
    driverName?: string;
    /**
     * 乗務員番号
     * @type {string}
     * @memberof ReserveShiftsReportRow
     */
    driverCode?: string;
    /**
     * 要指導休憩
     * @type {string}
     * @memberof ReserveShiftsReportRow
     */
    needGuidanceBreaks?: string;
    /**
     * 要指導ナビ
     * @type {string}
     * @memberof ReserveShiftsReportRow
     */
    needGuidanceHermes?: string;
    /**
     * 要指導営収
     * @type {string}
     * @memberof ReserveShiftsReportRow
     */
    needGuidanceEarnings?: string;
    /**
     * 乗務時間（分）
     * @type {number}
     * @memberof ReserveShiftsReportRow
     */
    shiftLengthMin?: number;
    /**
     * 休憩時間（分）
     * @type {number}
     * @memberof ReserveShiftsReportRow
     */
    breaksLengthMin?: number;
    /**
     * 配車一時停止時間（分）
     * @type {number}
     * @memberof ReserveShiftsReportRow
     */
    pauseCarRequestLengthMin?: number;
    /**
     * 承諾率
     * @type {number}
     * @memberof ReserveShiftsReportRow
     */
    acceptanceRate?: number;
    /**
     * ナビ利用率
     * @type {number}
     * @memberof ReserveShiftsReportRow
     */
    naviUsageRate?: number;
    /**
     * 時間営収
     * @type {number}
     * @memberof ReserveShiftsReportRow
     */
    timeEarnings?: number;
}

export function ReserveShiftsReportRowFromJSON(json: any): ReserveShiftsReportRow {
    return ReserveShiftsReportRowFromJSONTyped(json, false);
}

export function ReserveShiftsReportRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReserveShiftsReportRow {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'shiftId': !exists(json, 'shift_id') ? undefined : json['shift_id'],
        'shiftDate': !exists(json, 'shift_date') ? undefined : json['shift_date'],
        'officeId': !exists(json, 'office_id') ? undefined : json['office_id'],
        'officeName': !exists(json, 'office_name') ? undefined : json['office_name'],
        'driverId': !exists(json, 'driver_id') ? undefined : json['driver_id'],
        'driverName': !exists(json, 'driver_name') ? undefined : json['driver_name'],
        'driverCode': !exists(json, 'driver_code') ? undefined : json['driver_code'],
        'needGuidanceBreaks': !exists(json, 'need_guidance_breaks') ? undefined : json['need_guidance_breaks'],
        'needGuidanceHermes': !exists(json, 'need_guidance_hermes') ? undefined : json['need_guidance_hermes'],
        'needGuidanceEarnings': !exists(json, 'need_guidance_earnings') ? undefined : json['need_guidance_earnings'],
        'shiftLengthMin': !exists(json, 'shift_length_min') ? undefined : json['shift_length_min'],
        'breaksLengthMin': !exists(json, 'breaks_length_min') ? undefined : json['breaks_length_min'],
        'pauseCarRequestLengthMin': !exists(json, 'pause_car_request_length_min') ? undefined : json['pause_car_request_length_min'],
        'acceptanceRate': !exists(json, 'acceptance_rate') ? undefined : json['acceptance_rate'],
        'naviUsageRate': !exists(json, 'navi_usage_rate') ? undefined : json['navi_usage_rate'],
        'timeEarnings': !exists(json, 'time_earnings') ? undefined : json['time_earnings'],
    };
}

export function ReserveShiftsReportRowToJSON(value?: ReserveShiftsReportRow | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'shift_id': value.shiftId,
        'shift_date': value.shiftDate,
        'office_id': value.officeId,
        'office_name': value.officeName,
        'driver_id': value.driverId,
        'driver_name': value.driverName,
        'driver_code': value.driverCode,
        'need_guidance_breaks': value.needGuidanceBreaks,
        'need_guidance_hermes': value.needGuidanceHermes,
        'need_guidance_earnings': value.needGuidanceEarnings,
        'shift_length_min': value.shiftLengthMin,
        'breaks_length_min': value.breaksLengthMin,
        'pause_car_request_length_min': value.pauseCarRequestLengthMin,
        'acceptance_rate': value.acceptanceRate,
        'navi_usage_rate': value.naviUsageRate,
        'time_earnings': value.timeEarnings,
    };
}


